
import Vue from "vue";
import store from "@/store";
import { APPLICATION } from "@/store/applications";
import { ROUTE_NAMES } from "@/routes";
import { IRootState } from "@/store/types";
import { TASK } from "@/store/task";
import { required } from "vuelidate/lib/validators";
import { accountNumber } from "@/validators";

export default Vue.extend({
  data() {
    return {
      accountNumber: "",
      isLoading: false
    };
  },
  computed: {
    task() {
      return store.state.application.modifyAccountNumberTask;
    },
    showModal: {
      get(): any {
        return !!this.task;
      },
      set(value: any) {
        if (!value) {
          store.commit(
            APPLICATION.NS(APPLICATION.MUTATIONS.SET_MODIFY_ACCOUNT_NUMBER_TASK),
            null
          );
        }
      }
    },
    applicationId(): any {
      return this.$route.params && this.$route.params.id;
    }
  },
  methods: {
    async onModifyAccountNumber() {
      const action = APPLICATION.NS(
        APPLICATION.ACTIONS.MODIFY_ACCOUNT_NUMBER_COMPLETE
      );
      if (this.task) {
        this.isLoading = true;
        const taskId = this.task.taskId;
        const success = await store.dispatch(action, {
          taskId,
          accountNumber: this.accountNumber
        });
        this.isLoading = false;
        if (success) {
          // hide modal and reset form values
          this.showModal = false;
          this.resetForm();
        }
      }
    },
    async resetForm() {
      await this.$store.dispatch(
        APPLICATION.NS(APPLICATION.ACTIONS.LOAD_APPLICATION),
        this.applicationId
      );

      await this.$store.dispatch(
        TASK.NS(TASK.ACTIONS.LOAD_APPLICATION_TIMELINE),
        this.applicationId
      );
    }
  },
  validations: {
    accountNumber: {
      required,
      accountNumber
    }
  }
});
